export default __webpack_public_path__ + "static/bg-gabarito-b2cc2aee22f951be6dae8b68eb95bb77.jpg";